import { menuTypeDict } from '@/dictionary/menu'
import { companyTypeDict } from '@/dictionary/company'
import {
  platformFunctionModuleDict,
  workbenchServiceDict
} from '@/dictionary/system'

/**
 * 黑名单管理
 */
export default {
  path: 'blacklist',
  type: menuTypeDict.DIRECTORY.value,
  meta: {
    title: '黑名单管理',
    icon: 'icon-side__heimingdanguanli',
    layout: 'DefaultLayout'
  },
  applicableCompanyTypes: [
    { companyType: companyTypeDict.ENTERPRISE.value },
    { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
  ],
  platformAlias: [],
  applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
  roles: [
    platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
    platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
  ],
  superviseInstitutions: [],

  children: [
    // 黑名单列表
    {
      path: 'list',
      name: 'BlacklistList',
      component: '/supplier-manage-views/blacklist/list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '黑名单列表',
        cache: true,
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 操作记录
    {
      path: 'blacklistId/:blacklistId/operate-record',
      name: 'BlacklistOperateRecord',
      component: '/supplier-manage-views/blacklist/operate-record',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '操作记录',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 同步记录
    {
      path: 'sync-record',
      name: 'BlacklistSyncRecord',
      component: '/supplier-manage-views/blacklist/sync-record',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '同步记录',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 政府采购严重违法失信行为记录名单
    {
      path: 'illegal-untrust-list',
      name: 'BlacklistIllegalUntrustList',
      component: '/supplier-manage-views/blacklist/illegal-untrust-list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '政府采购严重违法失信行为记录名单',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 严重失信主体名单查询
    {
      path: 'serious-untrust-list',
      name: 'BlacklistSeriousUntrustList',
      component: '/supplier-manage-views/blacklist/serious-untrust-list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '严重失信主体名单查询',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    },

    // 经验异常名录
    {
      path: 'abnormal-operation-list',
      name: 'BlacklistAbnormalOperationList',
      component: '/supplier-manage-views/blacklist/abnormal-operation-list',
      type: menuTypeDict.MENU.value,
      meta: {
        title: '经营异常名录',
        hidden: true
      },
      applicableCompanyTypes: [
        { companyType: companyTypeDict.ENTERPRISE.value },
        { companyType: companyTypeDict.PUBLIC_INSTITUTION.value }
      ],
      platformAlias: [],
      applicableCompanyIdentities: [workbenchServiceDict.PURCHASER.value],
      roles: [
        platformFunctionModuleDict.SUPPLIER_MANAGEMENT.right,
        platformFunctionModuleDict.BUSINESS_MANAGEMENT.right
      ],
      superviseInstitutions: []
    }
  ]
}
